module.exports = __webpack_public_path__ + "img/images-user.dea6e660.svg";